var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pt-2",attrs:{"sm":"4"}},[_c('span',{staticClass:"caption"},[_vm._v(_vm._s(_vm.label))])]),_c('v-col',{attrs:{"sm":_vm.sm}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }